import React from 'react';

export default function CustomNav ({stan, hamburgerStan}){

    return(
        <div id='m-nav' className={`m-left ${ hamburgerStan ? 'hidden' : stan}`}>
        <ul>
            <li data-menuanchor="start" className='active'> {/* bez klasy active, menu nie dziala dobrze */}
                <a className=' navbar-hov' href='#start'>
                    <span></span>
                </a>
            </li>
            <li data-menuanchor="projects" className='active'> {/* bez klasy active, menu nie dziala dobrze */}
                <a className=' navbar-hov' href='#projects'>
                    <span></span>
                </a>
            </li>
            <li data-menuanchor="about">
                <a className=' navbar-hov' href='#about'>
                    <span></span>
                </a>
            </li>
            <li data-menuanchor="contact">
                <a className=' navbar-hov' href='#contact'>
                    <span></span>
                </a>
            </li>
        </ul>
    </div>
    )

}